var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"sr-status-badge",style:(_vm.style),attrs:{"pill":""}},[_vm._v("\n  "+_vm._s(_vm.associated)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }